module.exports = __webpack_public_path__ + "img/authbg.c9c51950.png";